<template>
  <div class="app-consumption-view" v-if="showConsumptions">
    <slot name="txtBefore">Verbrauchsanzeige</slot>
    <div v-for="item in optionsConsumptions" :key="item.id">
      <div class="consumption-box">
        <div class="consumption-options-name">
          <span v-html="item.name"></span>
          <span v-if="item.extraHtml" v-html="item.extraHtml"></span>
        </div>
        <div class="consumption-options-value">
          <span class="is-flat" v-if="item.isFlat">
            <slot name="txtUnlimitedVolume">Unbegrenztes Volumen</slot></span>
          <div v-if="!item.isFlat && item.consumptions.length > 0">
            <slot name="txtBeforeConsumption"><span class="txt-before-consumption">Verbräuche</span></slot>
            <div v-for="consumption in item.consumptions" :key="consumption.id">
              <slot :name="`txtBeforeConsumption${consumption.id}`"></slot>
              <b-progress :max="consumption.max">
                <b-progress-bar :value="consumption.left">
                  <div class="consumption-info">{{ consumption.left }} von {{ consumption.max }}
                    {{ units[consumption.unit] }} verfügbar
                  </div>
                </b-progress-bar>
              </b-progress>
              <slot :name="`txtAfterConsumption${consumption.id}`"></slot>
            </div>
          </div>
          <div v-else>
            <slot name="txtBeforeConsumption"><span class="txt-before-consumption">Keine Verbräuche vorhanden</span></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'

export const stepName = 'view'
export default {
  data () {
    return {
      consumptions: [],
      units: {
        QUANTITY: 'Einheiten',
        MINUTE: 'Minuten',
        GB: 'GB',
        MB: 'MB'
      }
    }
  },
  props: {
    extraTariffOptions: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    showConsumptions () {
      return (this.optionsConsumptions && this.optionsConsumptions.length > 0)
    },
    optionsConsumptions () {
      return this.consumptions?.consumptionsForTariffAndOptions?.filter(item => item.type === 'Tariffoption').map(tariffOption => {
        return Object.assign(
          {},
          tariffOption,
          (this.extraTariffOptions ? this.extraTariffOptions[tariffOption.id] || {} : {})
        )
      })
    }
  },
  name: 'ConsumptionView',
  apollo: {
    consumptions: function () {
      return wrapQuery(
        gql`query bookTariffOptions {
 consumptions {
    consumptionsForTariffAndOptions {
    consumptions {
      consumed,
      expirationDate,
      left,
      max,
      tariffOrOptions {
        id,
        isFlat,
        name,
        type,
      }
      type,
      unit
    }
    id,
    isFlat,
    name,
    type
    }
   }
        }`, this, 'consumptions'
      )
    }
  }
}
</script>
